export enum ComplaintType {
  WITHOUT = "without",
  YEAR = "year",
  HALF = "half",
  QUARTER = "quarter",
  MONTH = "month",
}

export const ComplaintTypeLabel = {
  [ComplaintType.WITHOUT]: "Ohne Beschwerde",
  [ComplaintType.YEAR]: "Beschwerden letzte 12 Monate",
  [ComplaintType.HALF]: "Beschwerden letzte 6 Monate",
  [ComplaintType.QUARTER]: "Beschwerden letzte 3 Monate",
  [ComplaintType.MONTH]: "Beschwerden letzter Monat",
};



// WEBPACK FOOTER //
// ./src/types/ComplaintType.tsx